module.exports = __webpack_public_path__ + "img/octopus-energy_80X30.b9250f26.png";